// extracted by mini-css-extract-plugin
export default {"Prices":"prices_Prices__S3EB6","LandingContent":"prices_LandingContent__BKn+D","Slogan":"prices_Slogan__zwQeb"};